import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

/* eslint-disable import/no-unresolved */
import { createGlobalStyle } from 'styled-components';
import designTokens from '@resultadosdigitais/tangram-design-tokens/tangram-design-tokens.css';
const DesignTokens = createGlobalStyle(_templateObject(), designTokens);
export default DesignTokens;